import clsx from 'clsx';

import { Tooltip } from 'shared/ui/tooltip';

import { useWalkthroughConfig } from '../../model';

import styles from './styles.module.scss';

export interface ProgressBarProps {
  activeIndex?: number;
  onBackButtonClick?: (e: React.MouseEvent<HTMLElement>) => void;
  classNames?: string;
}

export const ProgressBar = ({
  onBackButtonClick,
  activeIndex = 0,
  classNames,
}: ProgressBarProps) => {
  const config = useWalkthroughConfig();

  const renderCarouselDots = () => {
    if (!config) return null;

    return [...Array(config.count)].map((_, i) => (
      <li
        key={i}
        className={clsx(styles.navigationDot, {
          [styles.active]: i === activeIndex,
        })}
        data-testid="walkthrough-progress-dot"
      />
    ));
  };

  return (
    <div className={clsx(styles.container, classNames)}>
      <ul className={styles.navigationDotsContainer}>{renderCarouselDots()}</ul>
      {activeIndex !== 0 && (
        <div className={styles.buttonContainer}>
          <Tooltip title="back">
            <button
              onClick={onBackButtonClick}
              className="btn btn-icon-ghost"
              type="button"
              aria-label="Go back"
              data-testid="progress-back-button"
            >
              <i className="icon-v2-chevron-small-left" aria-hidden />
            </button>
          </Tooltip>
        </div>
      )}
    </div>
  );
};
